import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { PaginatedApiResponse } from '../models/paginated-api-response';
import { ListRequest } from '../models/requests/list-request';
import { HttpService } from './http.service';
import { Invoice, OblioClientCheck } from '../models/invoices/invoice';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(
    private http: HttpService,
    private configService: ConfigService
  ) {}

  getInvoices(request: ListRequest): Observable<PaginatedApiResponse<Invoice>> {
    return this.http
      .post(`invoice/list/`, request)
      .pipe(catchError(() => of(null)));
  }

  getGymInvoices(
    request: ListRequest
  ): Observable<PaginatedApiResponse<Invoice>> {
    return this.http
      .post(`invoice/admin-list/`, request)
      .pipe(catchError(() => of(null)));
  }

  verifyOblioClient(gymId: string): Observable<OblioClientCheck> {
    return this.http
      .get(`invoice/verify-client/${gymId}`)
      .pipe(catchError(() => of(null)));
  }

  getDownloadUrl(invoice: { downloadUrl?: string }) {
    // Oblio returns absolute links; only legacy relative paths need the API host
    return invoice.downloadUrl?.startsWith('http')
      ? invoice.downloadUrl
      : this.configService.config.apiUrl + invoice.downloadUrl;
  }
}
